module.exports = __webpack_public_path__ + "static/media/ic_logout.bffd07a8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/ic_logout.svg
// module id = 675
// module chunks = 0